import { Transform } from 'class-transformer';
import { IsIn, IsNotEmpty, IsOptional, IsString, IsUUID, MaxLength } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import {
  RECALL_DIRECTIONS,
  RECALL_KINDS,
  RECALL_SOURCES,
  type RecallDirection,
  type RecallKind,
  type RecallSource,
} from './recall.enums';

export class CreateRecallCaseDto {
  @IsIn(RECALL_DIRECTIONS)
  direction!: RecallDirection;

  @IsIn(RECALL_KINDS)
  kind!: RecallKind;

  @IsIn(RECALL_SOURCES)
  source!: RecallSource;

  @IsString()
  @IsNotEmpty()
  @MaxLength(200)
  @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
  productName!: string;

  @IsString()
  @IsOptional()
  @MaxLength(100)
  @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
  @OptionalStringTransform()
  supplierLotNumber?: string;

  @IsUUID()
  @IsOptional()
  supplierId?: string;

  /** Lotto di partenza per i casi ISSUED (matchReason ORIGIN). */
  @IsUUID()
  @IsOptional()
  originLotId?: string;

  @IsString()
  @IsOptional()
  @MaxLength(2000)
  @OptionalStringTransform()
  hazardDescription?: string;

  @IsString()
  @IsOptional()
  @MaxLength(2000)
  @OptionalStringTransform()
  instructions?: string;

  @IsString()
  @IsOptional()
  @MaxLength(4000)
  @OptionalStringTransform()
  notes?: string;
}
